import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './WholesaleTermination.css';

const WholesaleTermination = () => {
  return (
    <div className="wholesaletermination-container">
      {/* Hero Section */}
      <section className="wholesaletermination-hero">
        <motion.div 
          className="wholesaletermination-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="wholesaletermination-hero-title">Wholesale Termination Service</h1>
          <h2 className="wholesaletermination-hero-subtitle">
            Power Your Voice with Reliable, Flexible, and High-Quality VoIP Termination
          </h2>
          <Link to="/contact" className="wholesaletermination-cta-btn">
            <motion.button
              className="wholesaletermination-cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>
      </section>

      {/* Main Content */}
      <section className="wholesaletermination-content">
        <div className="wholesaletermination-content-container">
          <motion.div 
            className="wholesaletermination-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="wholesaletermination-section-text">
              Welcome to DirectRoutes Networks' Wholesale Termination Services, where exceptional quality meets a comprehensive suite of outbound voice products designed to elevate your communication experience. We provide a robust gateway to VoIP termination, offering flexibility, control, and enterprise-grade performance for carriers, service providers, and aggregators worldwide.
            </p>
          </motion.div>

          <motion.div 
            className="wholesaletermination-goals-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2 className="wholesaletermination-section-title">Explore Your Voice Communication Goals</h2>
            <p className="wholesaletermination-section-text">
              With DirectRoutes Networks, you have the freedom to define your communication strategy and achieve your growth objectives. Our outbound voice solutions deliver flexibility, control, and reliable call completion, empowering your business to scale efficiently while optimizing your voice operations.
            </p>
          </motion.div>

          <motion.div 
            className="wholesaletermination-quality-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <h2 className="wholesaletermination-section-title">Quality and Cost Synergy</h2>
            <p className="wholesaletermination-section-text">
              We combine high-quality voice termination with competitive, cost-effective solutions. Our services are designed to eliminate budget constraints while ensuring consistent call quality, so you can focus on business growth without compromise.
            </p>
          </motion.div>

          <motion.div 
            className="wholesaletermination-support-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <h2 className="wholesaletermination-section-title">World-Class Support</h2>
            <p className="wholesaletermination-section-text">
              Our commitment to world-class support ensures your network runs smoothly around the clock. We provide 24/7 monitoring of your traffic and a dedicated U.S.-based account management team to guarantee that every client receives responsive, proactive assistance.
            </p>
          </motion.div>

          <motion.div 
            className="wholesaletermination-features-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.0 }}
          >
            <h2 className="wholesaletermination-section-title">Key Features of Our Wholesale Termination Services:</h2>
            <ul className="wholesaletermination-features-list">
              <li>Local, national, and on-net termination</li>
              <li>Comprehensive A-Z VoIP coverage</li>
              <li>Precision-engineered call routes</li>
              <li>Industry-leading voice quality</li>
              <li>Flexible NPA-NXX or flat-rate pricing</li>
            </ul>
          </motion.div>

          <motion.div 
            className="wholesaletermination-conclusion"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.2 }}
          >
            <p className="wholesaletermination-section-text">
              Partner with DirectRoutes Networks for a wholesale termination solution that balances quality, reliability, and profitability, allowing your voice services to thrive in a competitive global market.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default WholesaleTermination;